var postsOnPage = $('.blog-grid-container');
var nextUrl = postsOnPage.attr("data-next-url");

var loadMoreBtn = $('#blogLoadMore');
var loadMoreSpinner = $('#BlogloadMoreSpinner');


function loadMorePosts() {
  console.log(nextUrl);
  console.log(postsOnPage);
  
    $.ajax(
        {
            url: nextUrl,
            type: 'GET',
            dataType: 'html',
            beforeSend: function() {
                loadMoreBtn.hide();
                loadMoreSpinner.show();
            }
        }
    ).done(function(nextPage) {
      
      	nextUrl = postsOnPage.attr("data-next-url");

        loadMoreSpinner.hide();

        var newPosts = $(nextPage).find('.blog-grid-container');
        var newUrl = newPosts.attr("data-next-url");

        if(newUrl)
          loadMoreBtn.show();
          nextUrl = newUrl;
          postsOnPage.append(newPosts.html());
        }
    )
}

$('.landing-page-reviews').slick({
    dots: true,
    prevArrow: false,
    nextArrow: false
  });